import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';
import { sanitizeReturnUrlAndRedirect } from '@/ui-kit/utils/sanitizeUrl';

export const useSearchParamsReturnUrl = () => {
    const [searchParams] = useSearchParams();
    const value = searchParams.get('returnUrl') ?? undefined;
    const doRedirect = useCallback(() => {
        value && sanitizeReturnUrlAndRedirect(value);
    }, [value]);
    return [value, doRedirect] as const;
};
